<div class="modal-container hidden" [class.hidden]="!isOpen" >
  <div class="inline-header">
    <button (click)="close()">
      <i class="now-ui-icons ui-1_simple-remove"></i>
    </button>
  </div>
  @if (contentComponentFactory$ | async) {
  }
  <div class="modal-container-content" >
    <ng-template #modalContainer></ng-template>
  </div>
</div>
